let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("V5vNT")).then(() => parcelRequire('3xmZq'));